/**
 * Marqueur pose a cote du pseudo du streamer, en mode stream.
 *
 * Meme principe que BotTag : ce joueur ne joue pas comme les autres (il ne
 * dessine pas, il cherche seul, il ne marque aucun point), et cela doit se voir
 * partout ou son nom s'affiche. L'icone est decorative, le sens est porte par
 * le titre accessible.
 */
import type { ReactElement } from 'react';
import { useT } from '../locales/useT.js';
import { StreamIcon } from './icons.js';

export function StreamTag({ size = 14 }: { readonly size?: number }): ReactElement {
  const t = useT();
  return (
    <span className="stream-tag" title={t('game.streamer')}>
      <StreamIcon size={size} />
      <span className="visually-hidden">{t('game.streamer')}</span>
    </span>
  );
}
